import { useState } from "react";
import type { Dispatch, SetStateAction } from "react";
import type { LocationState } from "./useNavigationLogic";

interface NavigationState {
  direction: "next" | "previous";
  hasNextPage: boolean;
  isPostQueryEnabled: boolean;
  setDirection: Dispatch<SetStateAction<"next" | "previous">>;
  setHasNextPage: Dispatch<SetStateAction<boolean>>;
  setIsPostQueryEnabled: Dispatch<SetStateAction<boolean>>;
}

export const useNavigationState = (
  locationState?: LocationState,
): NavigationState => {
  const [direction, setDirection] = useState<"next" | "previous">("next");
  const [isPostQueryEnabled, setIsPostQueryEnabled] = useState(false);
  const [hasNextPage, setHasNextPage] = useState(
    locationState?.hasNextPage ?? false,
  );

  return {
    direction,
    setDirection,
    isPostQueryEnabled,
    setIsPostQueryEnabled,
    hasNextPage,
    setHasNextPage,
  };
};
